<template>
  <div class="snack-stack">
    <!-- <v-btn
      @click="
        addMessage(
          'There are many variations of passages of Lorem Ipsum available, bundomised words which d',
          1
        )
      "
      >add message</v-btn
    > -->
    <v-card
      class="py-10px pl-15px pr-10px mb-10px snack-message"
      :class="[m.isError ? 'snack-error' : 'snack-ok']"
      v-for="(m, i) in messages"
      :key="i"
    >
      <v-row no-gutters>
        <v-col cols="10">
          <span class="snack-text">{{ m.message }}</span>
        </v-col>
        <v-col cols="2">
          <div class="snack-btn">
            <v-btn class="link pa-0" elevation="0" small @click="removeMessage(m.id)"
              >Zavrieť</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { eventBus } from '../../main.js';

export default {
  data() {
    return {
      messages: [],
      counter: 0,
    };
  },
  props: {
    timeout: {
      type: Number,
      default: 10000,
    },
  },
  methods: {
    addMessage(message, isError, infinite) {
      const cmp = this;
      const messageObject = new (function () {
        this.message = message;
        this.id = cmp.counter++;
        this.isError = isError;

        if (cmp.timeout > 0 && !infinite) {
          setTimeout(() => {
            //cmp.messages = cmp.messages.filter(m => m.id !== this.id);
            cmp.removeMessage(this.id);
          }, cmp.timeout);
        }
      })();
      this.messages.push(messageObject);
    },
    removeMessage(id) {
      this.messages = this.messages.filter(m => m.id !== id);
    },
  },
  created() {
    eventBus.$on('snack-error', message => {
      this.addMessage(message, 1);
    });
    eventBus.$on('snack-error-i', message => {
      this.addMessage(message, 1, true);
    });
    eventBus.$on('snack-info', message => {
      this.addMessage(message, 0);
    });
  },
};
</script>
<style lang="sass"></style>
